import {
  SHARE_TRIBUN_COUPON_REQUEST,
  SHARE_TRIBUN_COUPON_SUCCESS,
  SHARE_TRIBUN_COUPON_FAILURE
} from 'Store/constants';

const initailState = {
  data: null,
  isLoading: false,
  error: null
};

export default (state = initailState, action ) => {
  switch (action.type) {
    case SHARE_TRIBUN_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHARE_TRIBUN_COUPON_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case SHARE_TRIBUN_COUPON_FAILURE:
      return { ...state, isLoading: false, error: null };
    default:
      return state;
  }
};